import { render, staticRenderFns } from "./AccountOpening.vue?vue&type=template&id=022e1a7a&scoped=true&"
import script from "./AccountOpening.vue?vue&type=script&lang=ts&"
export * from "./AccountOpening.vue?vue&type=script&lang=ts&"
import style0 from "./AccountOpening.vue?vue&type=style&index=0&id=022e1a7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e1a7a",
  null
  
)

export default component.exports